import axios from "../axiosInstance";
import { FetchCampaignProductsResponse } from "./types";

export const fetchCampaignProducts =
  async (): Promise<FetchCampaignProductsResponse> => {
    const response = await axios.get<FetchCampaignProductsResponse>(
      "/api/private/campaign-products?pageSize=1000&active=",
    );
    return response.data;
  };
